import Axios from "api/Axios";
import AutomateAxios from "api/Axios/automateAxios";

export const getForecast = async (payload) => {

    // const urlencoded = new URLSearchParams();
    // urlencoded.append('question', payload.question);
    // urlencoded.append('dataframe', payload.dataframe);

    const response = await Axios.post(`/get_forecast/`, payload, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export const downvoteMessage = async (payload) => {
    const response = await Axios.post(`/log_downvote/`, payload);
    return {
        ...response.data,
        success: response.status === 200,
    };
}

export const formAutomate = async (payload) => {
    const response = await Axios.post('/agent', payload);
    return {
        ...response.data,
        success: response.status === 200,
    };
}

export const meetAutomate = async (payload) => {
    const { user_id, ...rest } = payload;

    const response = await AutomateAxios.post(`/webhook/storymetricsCodewave?user_id=${user_id}`, rest);
    return {
        ...response.data,
        success: response.status === 200,
    };
};

export const notification = async (payload) => {
    const response = await Axios.get('/notifications', payload);
    return {
        ...response.data,
        success: response.status === 200,
    };
}

export const generateFromSurveyLinks = async (payload) => {
    const response = await AutomateAxios.post('/webhook/afdfefcf-ddbf-4449-925f-0599a8be9624', payload);
    return {
        ...response.data,
        success: response.status === 200,
    };
}

export const ShareFormSurveyLink = async (payload) => {
    const response = await AutomateAxios.post('webhook/sm_forms/share_forms', payload);
    return {
        ...response.data,
        success: response.status === 200,
    };
}

export const checkForecastability = async (payload) => {
    const { askedQuestion, ...body } = payload;
    const response = await Axios.post(`/forecastability/`, body,
        {
            params: {
                question: askedQuestion
            }
        }
    );
    return {
        ...response.data,
        success: response.status === 200,
    };
}